export function useSetStorageSerializer<T>() {
  return {
    read: (raw: string): Set<T> | null => {
      const parsed = JSON.parse(raw)
      return parsed && parsed.length > 0 ? new Set(parsed as T[]) : null
    },
    write: (value: Set<T> | null) => {
      return JSON.stringify(value ? Array.from(value) : null)
    },
  }
}
